
export const getOktaAuthClient = ({ clientId, issuer, redirectUri }) => {
  return new OktaAuth({
    clientId,
    issuer,
    redirectUri,
    pkce: false,
    responseType: ['code'],
    scopes: ['openid', 'profile', 'email'],
  })
}